import { heroFeature } from "@/mocks/home";

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20dramatic%20theatre%20scene%20with%20deep%20crimson%20curtains%20and%20warm%20amber%20spotlights%20cutting%20through%20haze%2C%20blurred%20silhouette%20crowd%20in%20distance%2C%20cinematic%20moody%20atmosphere%2C%20rich%20dark%20background%20with%20warm%20gold%20highlights%2C%20editorial%20photography%2C%20no%20text&width=1800&height=1000&seq=hl-hero-01&orientation=landscape"
          alt="黑料视频 首屏主视觉"
          title="黑料视频 最新热传"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/55 to-black/75"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-transparent"></div>
      </div>

      <div className="relative z-10 mx-auto flex min-h-[560px] max-w-7xl flex-col justify-center px-4 py-16 md:min-h-[660px] md:px-6 md:py-24">
        <div className="animate-rise">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-3.5 py-1.5 text-xs font-medium text-background-50">
            <span className="relative flex h-2 w-2 items-center justify-center">
              <span className="absolute inline-flex h-2 w-2 animate-live-dot rounded-full bg-background-50"></span>
            </span>
            {heroFeature.badge}
          </span>

          <h2 className="mt-6 max-w-3xl font-heading text-3xl font-bold leading-[1.25] text-background-50 md:text-5xl md:leading-[1.2]">
            {heroFeature.title}
          </h2>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200/90 md:text-base">
            {heroFeature.description}
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#latest"
              className="inline-flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-play-circle-line text-lg"></i>
              {heroFeature.primaryCta}
            </a>
            <a
              href="#subscribe"
              className="inline-flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-6 text-sm font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20"
            >
              <i className="ri-notification-3-line text-lg"></i>
              {heroFeature.secondaryCta}
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-background-200/75">
            {heroFeature.meta.map((item) => (
              <span key={item} className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-arrow-right-s-line text-accent-400"></i>
                {item}
              </span>
            ))}
          </div>
        </div>

        <div className="mt-10 grid w-full max-w-3xl grid-cols-1 gap-px overflow-hidden rounded-lg border border-background-50/15 bg-background-50/10 backdrop-blur-sm sm:grid-cols-3">
          {heroFeature.stats.map((stat) => (
            <div key={stat.label} className="bg-black/25 px-5 py-4">
              <p className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
                {stat.value}
              </p>
              <p className="mt-1 text-xs text-background-200/75">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}